/** 「最下部付近」とみなすスクロール残量 (px)。下向きの操作でここまで来たら追従を再開し、ジャンプボタンも隠す。 */
export const NEAR_BOTTOM_THRESHOLD_PX = 40;

/** 「最下部ぴったり」とみなす残量 (px)。ブラウザのズームでは最下部でも scrollTop の丸めで 1〜3px 残るため。 */
const AT_BOTTOM_TOLERANCE_PX = 4;

/** 次の scroll イベントまでのユーザー操作 (ホイール・キー) のスクロール方向。 */
export type ScrollIntent = "up" | "down" | null;

/** ユーザー操作のうち、上方向へ動かすキー / 下方向へ動かすキー。 */
const UP_KEYS = new Set(["ArrowUp", "PageUp", "Home"]);
const DOWN_KEYS = new Set(["ArrowDown", "PageDown", "End"]);

/** キー入力からスクロール方向を求める。スクロールに関係しないキーは null。 */
export function keyScrollIntent(key: string, shiftKey: boolean): ScrollIntent {
	if (UP_KEYS.has(key) || (key === " " && shiftKey)) return "up";
	if (DOWN_KEYS.has(key) || key === " ") return "down";
	return null;
}

/**
 * scroll イベントごとに、本文の伸長へ追従し続けるかを決める。
 * scroll イベントは 1 フレームに 1 回へまとめられ、描き足しの anchoring や追従の吸着と相殺されるため、
 * 止めるかどうかはスクロール量の向きより、ユーザー操作の向き (intent) を優先する。
 * 本文が縮んで scrollTop が下がっただけなら最下部のままなので止めない。
 * 再開は最下部に着いたとき、または下向きの操作で最下部付近まで来たときに限る (anchoring の下向き補正では再開しない)。
 */
export function nextFollowBottom(
	following: boolean,
	intent: ScrollIntent,
	scrollTopDelta: number,
	distanceFromBottom: number,
): boolean {
	if (distanceFromBottom <= AT_BOTTOM_TOLERANCE_PX) return true;
	if (intent === "up" || scrollTopDelta < 0) return false;
	if (intent === "down" && distanceFromBottom <= NEAR_BOTTOM_THRESHOLD_PX) return true;
	return following;
}
